// `normalize` function standardizes input strings by removing diacritic marks and converting to lowercase.
export const normalize = string_ => (string_ ?? '').normalize('NFD').replaceAll(/[\u0300-\u036F]/g, '').toLowerCase();